import _ from 'lodash';
import {
	NavigationTree,
	NavTreeItem,
} from '../../logic/domains/navigationTree.domain';
import { isInNavigationTree } from '../../logic/functions/common/navigationTreeCheck';

export const flattenNavTreeToRoutes = (
	navigationTree: NavigationTree,
	configuredRoutes: NavTreeItem[]
): NavTreeItem[] => {
	return _(navigationTree.menuData)
		.map(menuItem => configureAllRoutesForItem(menuItem, configuredRoutes))
		.flatten()
		.concat(
			getNonNavTreeConfiguredRoutes(navigationTree.menuData, configuredRoutes)
		)
		.value();
};

const configureAllRoutesForItem = (
	navigationItem: NavTreeItem,
	configuredRoutes: NavTreeItem[]
): NavTreeItem[] => {
	let routesForItem: NavTreeItem[] = new Array();
	const mappedNavItem = mapNavItemToRoute(navigationItem, configuredRoutes);
	if (mappedNavItem) {
		routesForItem.push(mappedNavItem);
	}
	routesForItem = routesForItem.concat(
		getSubpages(navigationItem, configuredRoutes)
	);
	return routesForItem;
};

const mapNavItemToRoute = (
	navigationItem: NavTreeItem,
	configuredRoutes: NavTreeItem[]
): NavTreeItem | undefined => {
	let matchedItem: NavTreeItem | undefined;
	matchedItem = _.find(configuredRoutes, (configuredRoute: NavTreeItem) => {
		return configuredRoute.key === navigationItem.key;
	});

	if (matchedItem) {
		return matchedItem;
	}
};

const getSubpages = (
	navigationItem: NavTreeItem,
	configuredRoutes: NavTreeItem[]
): NavTreeItem[] => {
	let subpageItems: NavTreeItem[] = new Array();
	if (navigationItem.subpages && navigationItem.subpages.length > 0) {
		navigationItem.subpages.forEach(subpage => {
			subpageItems = subpageItems.concat(
				configureAllRoutesForItem(subpage, configuredRoutes)
			);
		});
	}
	return subpageItems;
};

// Add the routes that are configured in the SPA but not returned by nabfeed into the navigation tree for routing
const getNonNavTreeConfiguredRoutes = (
	navigationTreeData: NavTreeItem[],
	configuredRoutes: NavTreeItem[]
): NavTreeItem[] => {
	let navItems: NavTreeItem[] = new Array();
	_.map(configuredRoutes, configuredRoute => {
		if (!isInNavigationTree(navigationTreeData, configuredRoute)) {
			navItems.push(configuredRoute);
		}

		if (configuredRoute.subpages && configuredRoute.subpages.length > 0) {
			navItems = navItems.concat(
				getNonNavTreeConfiguredRoutes(
					navigationTreeData,
					configuredRoute.subpages
				)
			);
			delete configuredRoute.subpages;
		}
	});

	return navItems;
};
